import React, { useState } from "react";
import {
  Grid,
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  Select,
  MenuItem,
  FormControl,
  Tabs,
  Tab,
} from "@material-ui/core";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { VscHome } from "react-icons/vsc";
import { TabContext, TabPanel } from "@material-ui/lab";
import Slider from "react-slick";

const useStyles = makeStyles((theme) => ({
  bannerBox: {
    position: "relative",
    padding: "100px 0px 50px",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      padding: "100px 0px 50px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "100px 0px 50px",
    },
    "& .MuiOutlinedInput-root": {
      width: "97px",
      border: "1px solid var(--Linear, #62D3F0)",
      borderRadius: "10px",
      background: "rgba(255, 255, 255, 0.20)",
    },

    "& .tabBox": {
      borderBottom: "1px solid rgba(0, 0, 0, 0.25)",
      gap: "60px",
      "& .MuiOutlinedInput-input": {
        padding: "10px 20px",
      },
      "& .MuiTabs-fixed": {
        overflowX: "auto !important",
      },
      "& .iconLabelBox": {
        gap: "9px",
      },
      "& .MuiTab-textColorInherit.Mui-selected": {
        borderBottom: "6px solid #62D3F0 ",
        borderRadius: "10px 10px 0px 0px",
        color: theme.palette.primary.main,
      },
    },
    "& .hovrInfo": {
      gap: "35px",
      "& h1": {
        fontSize: "80px",
        fontWeight: 600,
        color: theme.palette.primary.dark,
        textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        textAlign: "center",
        lineHeight: "80px",
        "& .developerTypo": {
          color: theme.palette.primary.main,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
        },
      },
      "& h6": {
        color: theme.palette.text.primary,
        textAlign: "center",
        paddingBottom: "130px",
        width: "100%",
        maxWidth: "1061px",
      },
    },
    "& .leftNft": {
      paddingTop: "87px",
      "& h1": {
        color: theme.palette.primary.dark,
        lineHeight: "65px",
        fontWeight: 700,
      },
      "& .pioneer": {
        color: theme.palette.text.primary,
        marginBottom: "57px",
      },
      "& .leftNFTIn": {
        alignItems: "start",
        marginBottom: "30px",
        gap: "14px",
        "& h6": {
          color: theme.palette.primary.dark,
          marginBottom: "7.88px",
        },
        "& p": {
          color: theme.palette.text.primary,
        },
      },
    },
    "& .MarketPlace": {
      "& h1": {
        textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        fontWeight: 700,
        textAlign: "center",
        color: theme.palette.primary.dark,
        lineHeight: "80px",
        "& span": {
          background:
            "var(--Linear, linear-gradient(262deg, #62D3F0 13.12%, #35A5F5 83.57%))",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          wordBreak: "break-all",
        },
      },
      "& .MarketGrid": {
        borderRadius: "15px",
        textAlign: "center",
        boxShadow: "0px 10px 40px 0px rgba(142, 182, 210, 0.40)",
        backgroundColor: theme.palette.background.default,
        padding: "71px 0",
        height: "290px",
        "& img": {
          marginBottom: "54px",
        },
        "& h2": {
          color: theme.palette.primary.dark,
          fontWeight: 800,
          marginBottom: "54px",
        },
      },
    },
    "& img": {
      width: "auto",
      maxWidth: "100%",
    },
    "& .textbox": {
      "& h1": {
        color: "#262626",
        maxWidth: "492px",
        lineHeight: "104px",
      },
      "& p": {
        color: "#78819F",
      },
    },
    "& .Partners": {
      padding: "43px 0px 71px",
      background: "#0000000A",
      "& h1": {
        textAlign: "center",
        textShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
        color: theme.palette.primary.dark,
        fontWeight: 700,
        marginBottom: "40px",
      },
      "& .LandingSlider": {
        "& .slick-track": {
          display: "flex",
          gap: "60px",
          alignItems: "center",
        },
      },
    },
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Banner() {
  const classes = useStyles();
  const [value, setValue] = useState(2);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const MarketPlaces = [
    {
      image: <img src="images/Goods.png" alt="goods" />,
      title: "80M +",
      subTitle: "Digital Goods",
    },
    {
      image: <img src="images/Collections.png" alt="goods" />,
      title: "2M +",
      subTitle: "Collections",
    },
    {
      image: <img src="images/Volume.png" alt="goods" />,
      title: "$10B +",
      subTitle: "Market Volume",
    },
  ];

  const MarqueeImages = [
    { image: <img src="images/u62.png" alt="Image 1" /> },
    { image: <img src="images/u63.png" alt="Image 2" /> },
    { image: <img src="images/u64.png" alt="Image 3" /> },
    { image: <img src="images/u65.png" alt="Image 4" /> },
    { image: <img src="images/u68.png" alt="Image 5" /> },
  ];
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 300,
    cssEase: "linear",
    variableWidth: true,
    pauseOnHover: false,
  };

  return (
    <Box className={classes.bannerBox}>
      <Container>
        <Box className="displayStart tabBox">
          <FormControl variant="outlined">
            <Select defaultValue="V1" variant="outlined">
              <MenuItem value="V1">V1</MenuItem>
              <MenuItem value="V2">Another Option</MenuItem>
            </Select>
          </FormControl>

          <TabContext value={value}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label={
                  <Box className="iconLabelBox displayStart">
                    <VscHome fontSize="20px" />
                    <Typography variant="h6">Home</Typography>
                  </Box>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <Box className="iconLabelBox displayStart">
                    <img src="images/api.png" alt="sound" />
                    <Typography variant="h6">API Reference</Typography>
                  </Box>
                }
                {...a11yProps(1)}
              />
              <Tab
                label={
                  <Box className="iconLabelBox displayStart">
                    <img src="images/sound.png" alt="sound" />
                    <Typography variant="h6">Changelog</Typography>
                  </Box>
                }
                {...a11yProps(2)}
              />
            </Tabs>

            <TabPanel value="0" index={0}>
              Item One
            </TabPanel>
            <TabPanel value="1" index={1}>
              Item Two
            </TabPanel>
            <TabPanel value="2" index={2}>
              Item Three
            </TabPanel>
          </TabContext>
        </Box>

        <Box mt={7} className="displayColumnCenter hovrInfo">
          <Typography variant="h1">
            Hovr&nbsp;
            <span className="developerTypo">Developer</span> Platform
          </Typography>
          <Box>
            <Typography variant="h6">
              As the pioneering and leading marketplace for Non-Fungible Tokens
              and Semi-Fungible Tokens, Hovr offers a cutting-edge developer
              platform comprising an API, and developer tutorials. Explore the
              platform to familiarize yourself with smart contract development
              and engaging with NFT data
            </Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box className="leftNft">
              <Typography variant="h1">Lorem Ipsum</Typography>
              <Typography variant="h6" className="pioneer">
                Lorem ipsum is a placeholder text commonly used to demonstrate
                the visual form of a document or a typeface
              </Typography>
              <Box>
                <Box className="displayStart leftNFTIn">
                  <img src="images/NFT1.png" alt="" />
                  <Box>
                    <Typography variant="h6">NFTs</Typography>
                    <Typography variant="body2">
                      Filter by collection, type, or wallet address.
                    </Typography>
                  </Box>
                </Box>

                <Box className="displayStart leftNFTIn">
                  <img src="images/NFT2.png" alt="" />
                  <Box>
                    <Typography variant="h6">Activity</Typography>
                    <Typography variant="body2">
                      Get all NFT related events (not just on our marketplace)
                      including sales, listings, bids, transfers, and more.
                    </Typography>
                  </Box>
                </Box>

                <Box className="displayStart leftNFTIn">
                  <img src="images/NFT3.png" alt="" />
                  <Box>
                    <Typography variant="h6">Accounts</Typography>
                    <Typography variant="body2">
                      Get profile information for wallet addresses.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box>
              <img src="images/NFT-download.svg" alt="" height="610px" />
            </Box>
          </Grid>
        </Grid>

        <Box mt={10}>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Box>
                <img src="images/Landing1.png" alt="Increase" height="527px" />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className="leftNft">
                <Typography variant="h1">Lorem Ipsum</Typography>

                <Box mt={5}>
                  <Box className="displayStart leftNFTIn">
                    <img src="images/NFT1.png" alt="nft" />
                    <Box>
                      <Typography variant="h6">Buy, Sell & Bundle </Typography>
                      <Typography variant="body2">
                        Enable users to create auctions (w/o paying gas) in any
                        currency, bid on items, and create multi-item bundles
                      </Typography>
                    </Box>
                  </Box>

                  <Box className="displayStart leftNFTIn">
                    <img src="images/NFT2.png" alt="nft" />
                    <Box>
                      <Typography variant="h6">Activity</Typography>
                      <Typography variant="body2">
                        Access the Hovr API with a JavaScript wrapper, enabling
                        you to search NFTs, collections, users, and more.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="MarketPlace" mt={10} mb={16}>
          <Box mb={8}>
            <Typography variant="h1">
              Build on the largest&nbsp;<span>Marketplace</span> for digital
              items
            </Typography>
          </Box>

          <Box>
            <Grid container spacing={3}>
              {MarketPlaces.map((marketPlace, index) => {
                return (
                  <Grid item key={index} xs={12} sm={4}>
                    <Box className=" MarketGrid">
                      <Box>{marketPlace.image}</Box>
                      <Typography variant="h2">{marketPlace.title}</Typography>
                      <Typography variant="h4">
                        {marketPlace.subTitle}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Container>
      <Box className="Partners">
        <Typography variant="h1">Partners</Typography>

        <Slider {...settings} className="LandingSlider">
          {MarqueeImages.map((imageUrl, index) => (
            <Box display="flex" key={index}>
              {imageUrl.image}
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
}
